import "./DateTimeTools.css"
import ToolHeader from "../../Components/ToolHeader";
import { Row, Col } from "react-bootstrap";
import { useState, useEffect } from "react";

import { getTimezones, TimezoneConvert } from "../../Services/APIService";
import { ReactComponent as CopyIcon } from "../../Icons/Copy.svg";
import { ReactComponent as XIcon } from "../../Icons/x.svg";
import { ReactComponent as ArrowIcon } from "../../Icons/arrow-right.svg"


function TimeZoneConverter() {
    const toolFav = { toolName: 'Time Zone Converter', Iconpath: "/FileCodeRaw.svg" };

    

    

    const [fromZone, setFromZone] = useState("UTC");
    const [selectedZones, setSelectedZones] = useState([
        "Asia/Kolkata",
        "Europe/Paris",
        "America/Los_Angeles"
    ]);
    const [timezoneOptions, setTimezoneOptions] = useState([]);
    const [newZone, setNewZone] = useState("");
    const [hasCopied, sethasCopied] = useState(false)

    const getDefaultTimeSlot = () => {
        const now = new Date();
        const end = new Date(now.getTime() + 60 * 60 * 1000);

        const formatDate = (date) => `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
        const formatTime = (date) => {
            const hours = date.getHours();
            const minutes = String(date.getMinutes()).padStart(2, "0");
            const suffix = hours >= 12 ? "PM" : "AM";
            const formattedHour = hours % 12 || 12;
            return `${formattedHour}:${minutes} ${suffix}`;
        };

        return {
            date: formatDate(now),
            startTime: formatTime(now),
            endTime: formatTime(end)
        };
    };

    const [timeSlots, setTimeSlots] = useState(() => [getDefaultTimeSlot()]);
    const [conversionResult, setConversionResult] = useState(null);
    const [conversionError, setConversionError] = useState("");
    const [isConverting, setIsConverting] = useState(false);
    const maxSelectedZones = 4;
    const canAddZone = selectedZones.length < maxSelectedZones;
    const displayedTimezoneOptions = Array.from(
        new Set(["UTC", fromZone, ...selectedZones, ...timezoneOptions].filter(Boolean))
    );

    useEffect(() => {
        const loadTimezones = async () => {
            try {
                const response = await getTimezones();
                const data = response?.data;
                if (Array.isArray(data) && data.length > 0) {
                    setTimezoneOptions(data);
                }
            } catch (error) {
                console.error("Failed to fetch timezones:", error);
            }
        };

        loadTimezones();
    }, []);

    const handleAddZone = () => {
        if (!newZone || !canAddZone) return;

        const newZoneId = getTimeZoneId(newZone);
        const alreadySelected = selectedZones.some((zone) => getTimeZoneId(zone) === newZoneId);

        if (alreadySelected) {
            alert("cannot add the same time zone again");
            return;
        }

        if (newZone) {
            setSelectedZones([
                ...selectedZones,
                newZone
            ]);
            setNewZone("");
        }
    };

    const handleRemoveZone = (zoneToRemove) => {
        setSelectedZones(selectedZones.filter((zone) => zone !== zoneToRemove));
    };

    const removeTimeSlot = (index) => {
        const updated = [...timeSlots];
        updated.splice(index, 1);
        setTimeSlots(updated);
    };

    const addTimeSlot = () => {
        setTimeSlots([
            ...timeSlots,
            {
                date: "",
                startTime: "",
                endTime: ""
            }
        ]);
    };

    const handleChange = (
        index,
        field,
        value
    ) => {
        const updated = [...timeSlots];
        updated[index][field] = value;
        setTimeSlots(updated);
    };

    const formatDateForInput = (dateString) => {
        const parts = dateString.split("/");
        if (parts.length !== 3) return "";
        const [day, month, year] = parts;
        return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    };

    const formatDateFromInput = (value) => {
        if (!value) return "";
        const parts = value.split("-");
        if (parts.length !== 3) return value;
        const [year, month, day] = parts;
        return `${day}/${month}/${year}`;
    };

    const formatTimeForInput = (timeString) => {
        if (!timeString) return "";
        const match = timeString.match(/^(\d{1,2}):(\d{2})\s*(AM|PM)$/i);
        if (!match) return timeString;
        let [, hour, minute, meridiem] = match;
        hour = parseInt(hour, 10);
        if (meridiem.toUpperCase() === "PM" && hour < 12) {
            hour += 12;
        }
        if (meridiem.toUpperCase() === "AM" && hour === 12) {
            hour = 0;
        }
        return `${hour.toString().padStart(2, "0")}:${minute}`;
    };

    const formatTimeFromInput = (value) => {
        if (!value) return "";
        const [hourString, minute] = value.split(":");
        let hour = parseInt(hourString, 10);
        const meridiem = hour >= 12 ? "PM" : "AM";
        if (hour === 0) {
            hour = 12;
        } else if (hour > 12) {
            hour -= 12;
        }
        return `${hour.toString().padStart(2, "0")}:${minute} ${meridiem}`;
    };

    const getTimeZoneId = (zoneName) => {
        const mappings = {
            "Singapore": "Asia/Singapore",
            "India": "Asia/Kolkata",
            "London": "Europe/London",
            "New York": "America/New_York",
            "Berlin": "Europe/Berlin",
            "Tokyo": "Asia/Tokyo",
            "Sydney": "Australia/Sydney",
            "Dubai": "Asia/Dubai",
            "Calcutta": "Asia/Kolkata",
            "EDT": "America/New_York",
            "Singapore - Asia/Singapore": "Asia/Singapore",
            "India - Asia/Kolkata": "Asia/Kolkata",
            "London - Europe/London": "Europe/London"
        };
        if (mappings[zoneName]) return mappings[zoneName];
        if (zoneName === "UTC" || zoneName.includes("/")) return zoneName;
        return "UTC";
    };

    const parseTime = (timeString) => {
        const match = timeString.match(/^(\d{1,2}):(\d{2})\s*(AM|PM)$/i);
        if (!match) return null;
        let [, hour, minute, meridiem] = match;
        hour = parseInt(hour, 10);
        minute = parseInt(minute, 10);
        meridiem = meridiem.toUpperCase();
        if (meridiem === "AM" && hour === 12) {
            hour = 0;
        }
        if (meridiem === "PM" && hour < 12) {
            hour += 12;
        }
        return { hour, minute };
    };

    const buildSourceInstant = (dateString, timeString, timezone) => {
        const time = parseTime(timeString);
        if (!time) return null;
        const [day, month, year] = dateString.split("/").map(Number);
        const desiredUtc = Date.UTC(year, month - 1, day, time.hour, time.minute);
        const candidateInstant = new Date(desiredUtc);
        const formatParts = new Intl.DateTimeFormat("en-US", {
            timeZone: timezone,
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            hour12: false
        }).formatToParts(candidateInstant);
        const parts = Object.fromEntries(formatParts.filter((p) => p.type !== "literal").map((p) => [p.type, p.value]));
        const candidateLocalUtc = Date.UTC(
            Number(parts.year),
            Number(parts.month) - 1,
            Number(parts.day),
            Number(parts.hour),
            Number(parts.minute)
        );
        const offsetMs = desiredUtc - candidateLocalUtc;
        return new Date(candidateInstant.getTime() + offsetMs);
    };

    const formatZoneTime = (instant, timezone) => {
        if (!instant) return "";
        return new Intl.DateTimeFormat("en-US", {
            timeZone: timezone,
            hour: "numeric",
            minute: "2-digit",
            hour12: true
        }).format(instant);
    };

    const formatZoneDate = (instant, timezone) => {
        if (!instant) return "";
        return new Intl.DateTimeFormat("en-US", {
            timeZone: timezone,
            month: "short",
            day: "numeric"
        }).format(instant);
    };

    const formatSlotRange = (slot, timezone) => {
        const startInstant = buildSourceInstant(slot.date, slot.startTime, getTimeZoneId(fromZone));
        const endInstant = buildSourceInstant(slot.date, slot.endTime, getTimeZoneId(fromZone));
        if (!startInstant || !endInstant) return "";
        const startDate = formatZoneDate(startInstant, timezone);
        const endDate = formatZoneDate(endInstant, timezone);
        const startTime = formatZoneTime(startInstant, timezone);
        const endTime = formatZoneTime(endInstant, timezone);
        if (startDate === endDate) {
            return `${startDate} ${startTime} - ${endTime}`;
        }
        return `${startDate} ${startTime} - ${endDate} ${endTime}`;
    };

    const formatSlotLabel = (slot) => {
        const inputDate = formatDateForInput(slot.date) || slot.date;
        return {
            date: inputDate,
            time: `${formatTimeForInput(slot.startTime) || slot.startTime}-${formatTimeForInput(slot.endTime) || slot.endTime}`
        };
    };

    const [showTable, setShowTable] = useState(false);

    const buildApiDateTime = (slot) => {
        const date = formatDateForInput(slot.date);
        const time = formatTimeForInput(slot.startTime);
        if (!date || !time) return "";
        return `${date}T${time}:00`;
    };

    const formatConvertedTime = (value) => {
        if (!value) return "";
        const cleaned = value.replace(/\[[^\]]+\]$/, "");
        const date = new Date(cleaned);
        if (Number.isNaN(date.getTime())) return value;
        return date.toLocaleString("en-US", {
            year: "numeric",
            month: "short",
            day: "numeric",
            hour: "numeric",
            minute: "2-digit",
            hour12: true
        });
    };

    const handleConvertTimezones = async () => {

        if(timeSlots.length === 0) {
            setConversionResult(null);  
            setConversionError("Please add at least one time slot to convert.");    
            return;
        }
        const slot = timeSlots[0];
        const dateTime = buildApiDateTime(slot);

        if (!dateTime || !fromZone || selectedZones.length === 0 ) {
            setConversionResult(null);
            setConversionError("Enter a date, start time, end time, source timezone and at least one target timezone.");
            return;
        }

        const payload = {
            dateTime,
            fromTimezone: getTimeZoneId(fromZone),
            toTimezones: selectedZones.map(getTimeZoneId)
        };

        try {
            setIsConverting(true);
            setConversionError("");
            const response = await TimezoneConvert(payload);
            setConversionResult(response.data);
            // setShowTable(true);
        } catch (error) {
            setConversionResult(null);
            setConversionError(`Failed to convert timezones: ${error.message}`);
        } finally {
            setIsConverting(false);
        }
    };

    const copyConvertedTimes = () => {
        if (!conversionResult) return;
        navigator.clipboard.writeText(JSON.stringify(conversionResult, null, 2));
        sethasCopied(true);
        setTimeout(() => {
            sethasCopied(false);
        }, 2000);
    };

    return (
        <>
            <Col>
                <ToolHeader title="Time Zone Converter" description="Convert time slots from a source timezone to multiple targets" toolFav={toolFav} />
                <Row >
                    <Col>
                        <div className="timezone-wrapper">
                            {/* Top Section */}
                            <div className="top-card">
                                <div className="from-section">
                                    <label>FROM</label>
                                    <select
                                        value={fromZone}
                                        onChange={(e) =>
                                            setFromZone(e.target.value)
                                        }
                                    >
                                        {displayedTimezoneOptions.map((zone) => (
                                            <option
                                                key={zone}
                                                value={zone}
                                            >
                                                {zone}
                                            </option>
                                        ))}
                                    </select>
                                    <button
                                        type="button"
                                        className="arrow-icon-button"
                                        onClick={handleConvertTimezones}
                                        disabled={isConverting}
                                        aria-label="Convert timezones"
                                    >
                                        <ArrowIcon className="arrow-icon" />
                                    </button>
                                </div>

                                <div className="zone-tags-row">
                                    {selectedZones.map((zone, index) => (
                                        <div
                                            key={index}
                                            className={`zone-tag zone-${index}`}
                                        >
                                            {zone}
                                            <button
                                                type="button"
                                                className="remove-zone-btn"
                                                onClick={() => handleRemoveZone(zone)}
                                                aria-label={`Remove ${zone}`}
                                            >
                                                <XIcon />
                                            </button>
                                        </div>
                                    ))}

                                    <select
                                        value={newZone}
                                        onChange={(e) =>
                                            setNewZone(e.target.value)
                                        }
                                        disabled={!canAddZone}
                                    >
                                        <option value="">
                                            {canAddZone ? "+ add zone" : "Max 4 zones"}
                                        </option>

                                        {displayedTimezoneOptions.map((zone) => (
                                            <option
                                                key={zone}
                                                value={zone}
                                            >
                                                {zone}
                                            </option>
                                        ))}
                                    </select>

                                    <button
                                        className="add-zone-btn"
                                        onClick={handleAddZone}
                                        disabled={!canAddZone || !newZone}
                                    >
                                        Add
                                    </button>
                                </div>
                            </div>

                            {/* Bottom Grid */}
                            <div className="bottom-grid">

                                {/* Time Input */}
                                <div className="time-card">
                                    <div className="card-title">
                                        Times to convert
                                    </div>

                                    {timeSlots.map((slot, index) => (
                                        <div
                                            className="time-slot-row"
                                            key={index}
                                        >
                                            <div className="date-input-group">

                                                <input
                                                    type="date"
                                                    id={`date-${index}`}
                                                    value={formatDateForInput(slot.date)}
                                                    onChange={(e) =>
                                                        handleChange(
                                                            index,
                                                            "date",
                                                            formatDateFromInput(
                                                                e.target.value
                                                            )
                                                        )
                                                    }
                                                    placeholder="DD/MM/YYYY"
                                                />
                                            </div>

                                            <div className="time-input-group">

                                                <input
                                                    type="time"
                                                    id={`starttime-${index}`}
                                                    value={formatTimeForInput(slot.startTime)}
                                                    onChange={(e) =>
                                                        handleChange(
                                                            index,
                                                            "startTime",
                                                            formatTimeFromInput(
                                                                e.target.value
                                                            )
                                                        )
                                                    }
                                                    aria-label="Start time"
                                                />
                                            </div>

                                            <span className="dash">
                                                →
                                            </span>

                                            <div className="time-input-group">

                                                <input
                                                    type="time"
                                                    id={`endtime-${index}`}
                                                    value={formatTimeForInput(slot.endTime)}
                                                    onChange={(e) =>
                                                        handleChange(
                                                            index,
                                                            "endTime",
                                                            formatTimeFromInput(
                                                                e.target.value
                                                            )
                                                        )
                                                    }
                                                    aria-label="End time"
                                                />
                                            </div>

                                            <XIcon
                                                className="delete-icon headerIcon"
                                                onClick={() =>
                                                    removeTimeSlot(index)
                                                }
                                            />
                                        </div>
                                    ))}

                                    <div
                                        className="add-slot"
                                        onClick={addTimeSlot}
                                    >
                                        + Add time slot
                                    </div>
                                </div>

                                {/* Converted Output */}
                                <div className="converted-card">
                                    <div className="converted-header">
                                        <span>
                                            Converted times
                                        </span>

                                        <div className="actions">
                                            <span
                                                className="view-table-toggle"
                                                onClick={() => setShowTable(!showTable)}
                                            >
                                                {showTable ? "Hide table" : "View table"}
                                            </span>

                                            <span
                                                onClick={
                                                    copyConvertedTimes
                                                }
                                            >
                                                <CopyIcon />
                                                {hasCopied? "Copied": "Copy"}
                                            </span>
                                        </div>
                                    </div>

                                    {conversionError && (
                                        <div className="timezone-error-message">
                                            {conversionError}
                                        </div>
                                    )}

                                    {isConverting && (
                                        <div className="loading-text">
                                            Converting timezones...
                                        </div>
                                    )}

                                    {showTable ? (
                                        <div className="converted-table-wrapper">
                                            <table className="converted-table">
                                                <thead>
                                                    <tr>
                                                        <th>Slot</th>
                                                        <th className={`zone-heading ${fromZone.toLowerCase()}`}>{fromZone}</th>
                                                        {(conversionResult?.conversions || selectedZones.map((zone) => ({ timezone: zone }))).map((conversion) => (
                                                            <th className={`zone-heading ${conversion.timezone.toLowerCase()}`} key={conversion.timezone}>{conversion.timezone}</th>
                                                        ))}
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td>
                                                            <span className="slot-date">{formatSlotLabel(timeSlots[0]).date}</span>
                                                            <span className="slot-time">{formatTimeForInput(timeSlots[0].startTime) || timeSlots[0].startTime}</span>
                                                        </td>
                                                        <td>{conversionResult?.originalTime || formatSlotRange(timeSlots[0], getTimeZoneId(fromZone))}</td>
                                                        {conversionResult?.conversions ? (
                                                            conversionResult.conversions.map((conversion) => (
                                                                <td key={conversion.timezone}>
                                                                    <span>{formatConvertedTime(conversion.convertedTime)}</span>
                                                                    <span className="slot-time">{conversion.utcOffset} | {conversion.dayOfWeek}</span>
                                                                </td>
                                                            ))
                                                        ) : (
                                                            selectedZones.map((zone) => (
                                                                <td key={zone}>
                                                                    {formatSlotRange(timeSlots[0], getTimeZoneId(zone))}
                                                                </td>
                                                            ))
                                                        )}
                                                    </tr>
                                                    {timeSlots.slice(1).map((slot, index) => (
                                                        <tr key={index + 1}>
                                                            <td>
                                                                <span className="slot-date">{formatSlotLabel(slot).date}</span>
                                                                <span className="slot-time">{formatSlotLabel(slot).time}</span>
                                                            </td>
                                                            <td>{formatSlotRange(slot, getTimeZoneId(fromZone))}</td>
                                                            {selectedZones.map((zone) => (
                                                                <td key={zone}>
                                                                    {formatSlotRange(slot, getTimeZoneId(zone))}
                                                                </td>
                                                            ))}
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    ) : (
                                        <div className="converted-content">
                                            {conversionResult ? (
                                                conversionResult.conversions.map((conversion) => (
                                                    <div className="converted-zone-card" key={conversion.timezone}>
                                                        <span>{conversion.timezone}</span>
                                                        <strong>{formatConvertedTime(conversion.convertedTime)}</strong>
                                                        <small>{conversion.utcOffset} | {conversion.dayOfWeek} | DST: {conversion.daylightSavings ? "Yes" : "No"}</small>
                                                    </div>
                                                ))
                                            ) : (
                                                <span>Click the arrow to convert the selected time.</span>
                                            )}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Col >
        </>
    )
}

export default TimeZoneConverter;
